export const titleCase = (str) => {
  if (str === "" || str == null) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
